module.exports = __webpack_public_path__ + "static/img/logo_title.58736083.png";